import PropTypes from 'prop-types'
import React, { useState } from 'react'
import styles from './rsvp-by-host-accepted.scss'
import RsvpTitle from './RsvpTitle'
import TicketCountsSelector from './TicketCountsSelector'
import Button from '../common/Button'

const UpdateGuestCountView = ({
  displayName,
  ticketCounts,
  onConfirm,
  childCountEnabled
}) => {
  const [editTicketCounts, setEditTicketCounts] = useState(ticketCounts)

  const handleChangeCount = (id, count) => {
    const newCounts = editTicketCounts.map(item =>
      item.id === id ? { ...item, count } : item
    )
    setEditTicketCounts(newCounts)
  }

  const handleSaveChanges = () => {
    onConfirm({ ticketCounts: editTicketCounts })
  }

  const _validConfirm = () => {
    return !editTicketCounts.some(item =>
      (item.label === 'adult' || item.label === 'guest') && item.count > 0
    )
  }

  return (
    <div className={styles['container']}>
      <RsvpTitle
        title="Update Guest Count"
        subTitle={displayName}
        description={
          <div className={styles['update-guest-count-description']}>
            How many <strong>total guests</strong> are going?
          </div>
        }
      />
      <TicketCountsSelector
        ticketCounts={editTicketCounts}
        onChangeCount={handleChangeCount}
        child_count_enabled={childCountEnabled}
      />
      <Button
        onClick={handleSaveChanges}
        className={styles['confirm-button']}
        disabled={_validConfirm()}
      >
        save changes
      </Button>
    </div>
  )
}

UpdateGuestCountView.propTypes = {
  displayName: PropTypes.string,
  ticketCounts: PropTypes.array.isRequired,
  onConfirm: PropTypes.func.isRequired,
  childCountEnabled: PropTypes.bool
}

export default UpdateGuestCountView
